module.exports = __webpack_public_path__ + "static/day10-10ec0fa5b1ba9aa2f3add349d15951a3.png";